// En tu store (vuex)
const state = {
  visible: false,
  title: '',
  message: '',
  component: null,
  props: {},
  fields: [],
  actions: [],
  maxWidth: 500,
  persistent: false,
  scrollable: false,
  showClose: true,
  onConfirm: null
};

const mutations = {
  SHOW_DIALOG(state, options) {
    state.visible = true;
    state.title = options.title || '';
    state.message = options.message || '';
    state.component = options.component || null;
    state.props = options.props || {};
    state.fields = options.fields || [];
    state.actions = options.actions || [];
    state.maxWidth = options.maxWidth || 500;
    state.persistent = options.persistent || false;
    state.scrollable = options.scrollable || false;
    state.showClose = options.showClose !== undefined ? options.showClose : true;
    state.onConfirm = options.onConfirm || null;
  },
  closeDialog(state) {
    state.visible = false;
  }
};

const actions = {
  showDialog({ commit }, options) {
    commit('SHOW_DIALOG', options);
  },
  closeDialog({ commit }) {
    commit('closeDialog');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};